module.exports = __webpack_public_path__ + "static/media/bank.c290b0fd.svg";